import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  tag: {
    page: 0,
    size: 20,
    sortby: 'createdAt',
    sortdir: 'DESC',
    itemId: '',
    unit: '',
  },
}

const priceTableSlice = createSlice({
  name: 'priceTable',
  initialState,
  reducers: {
    setFetchOption(state, action) {
      state.tag = {
        ...state.tag,
        ...action.payload,
      }
    },
    resetFetchOption(state) {
      state.tag = initialState.tag
    },
  },
})

export const { setFetchOption, resetFetchOption } = priceTableSlice.actions

export default priceTableSlice.reducer
